/** NOTE: Route page, also used as pageID */
// main access point
const term_home = 'home';
const term_qrScanPay = 'qr-scan-pay';
const term_loginPay = 'login-pay';
const term_payment = 'payment';
const term_success = 'success';
const term_txn_pin = 'txn-pin';
const term_topup_options = 'topup-options';
const term_topup_payment = 'topup-payment';
const term_topup_success = 'topup-success';
const term_error = 'error';


/** Route url */
// const INDEX = '/';
const HOME = '';
const QRSCANPAY = term_qrScanPay;
const LOGINPAY = term_loginPay;
const PAYMENT = term_payment;
const SUCCESS = term_success;
const TXN_PIN = term_txn_pin;
const TOPUP_SUCCESS = term_topup_success;
const TOPUP_OPTIONS = term_topup_options;
const TOPUP_PAYMENT = term_topup_payment;
const ERROR = term_error;

const Routes = {
    term_home,
    term_qrScanPay,
    term_loginPay,
    term_payment,
    term_success,
    term_error,

    HOME,
    QRSCANPAY,
    LOGINPAY,
    PAYMENT,
    SUCCESS,
    ERROR,

    TXN_PIN,
    TOPUP_OPTIONS,
    TOPUP_PAYMENT,
    TOPUP_SUCCESS,
};

export default Routes;